import * as React from 'react'
import { memo } from 'react'
const SvgWhatsappFill = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 14 14"
  >
    <path
      d="M7.127 0A6.846 6.846 0 0 0 .25 6.82a6.75 6.75 0 0 0 .986 3.521L0 14l3.805-1.209A6.884 6.884 0 0 0 14 6.82 6.846 6.846 0 0 0 7.127 0m3.418 9.41a1.78 1.78 0 0 1-1.216.783c-.322.017-.332.25-2.089-.514a7.17 7.17 0 0 1-2.9-2.74 3.37 3.37 0 0 1-.648-1.827 1.95 1.95 0 0 1 .669-1.429.67.67 0 0 1 .476-.2h.33c.102 0 .256-.021.389.332s.454 1.225.494 1.313a.32.32 0 0 1 0 .305 1.2 1.2 0 0 1-.186.284c-.092.1-.193.22-.275.3s-.187.174-.091.352a5.3 5.3 0 0 0 .931 1.242 4.8 4.8 0 0 0 1.378.916c.172.094.275.083.382-.029s.457-.492.581-.662.239-.137.4-.073 1 .517 1.177.611.287.142.328.216a1.44 1.44 0 0 1-.131.82Z"
      data-name="Icon ionic-logo-whatsapp"
    />
  </svg>
)
const Memo = memo(SvgWhatsappFill)
export default Memo
